export default "__VITE_ASSET__D565KJvy__"